import React, {
  useState,
  useEffect,
  useContext,
  useReducer,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  AreaChart,
  BarChart,
  LineChart,
  ComposedChart,
  PieChart,
  RadarChart,
  RadialBarChart,
  ScatterChart,
  FunnelChart,
  Treemap,
  ResponsiveContainer,
  Legend,
  Tooltip,
  Cell,
  Text,
  Label,
  LabelList,
  Customized,
  Area,
  Bar,
  Line,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
  Brush,
  CartesianAxis,
  CartesianGrid,
  ReferenceLine,
  ReferenceDot,
  ReferenceArea,
  ErrorBar,
  Funnel,
  Cross,
  Curve,
  Dot,
  Polygon,
  Rectangle,
  Sector,
  Pie,
  Radar,
  RadialBar,
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
} from "recharts";

// react scope
const reactScope = {
  React,
  useState,
  useEffect,
  useContext,
  useReducer,
  useRef,
  useMemo,
  useCallback,
};

// recharts scope
const rechartsScope = {
  AreaChart,
  BarChart,
  LineChart,
  ComposedChart,
  PieChart,
  RadarChart,
  RadialBarChart,
  ScatterChart,
  FunnelChart,
  Treemap,
  ResponsiveContainer,
  Legend,
  Tooltip,
  Cell,
  Text,
  Label,
  LabelList,
  Customized,
  Area,
  Bar,
  Line,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
  Brush,
  CartesianAxis,
  CartesianGrid,
  ReferenceLine,
  ReferenceDot,
  ReferenceArea,
  ErrorBar,
  Funnel,
  Cross,
  Curve,
  Dot,
  Polygon,
  Rectangle,
  Sector,
  Pie,
  Radar,
  RadialBar,
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
};

// Export all the components and scope needed
export const scope = {
  ...reactScope,
  ...rechartsScope,
};
